module.exports = __webpack_public_path__ + "img/Badge_DIAMOND.8213bcf8.png";